/* eslint-disable no-console */
const hasDebugQueryParam = () => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('debug') === 'true';
};

let isDebugEnabled = hasDebugQueryParam();

export const enableDebugMode = () => {
  isDebugEnabled = true;
};

/** Test-only: restores the module-level debug flag to its initial URL-derived state */
export const resetDebugMode = () => {
  isDebugEnabled = hasDebugQueryParam();
};

const logToConsole = {
  /** Guard for callers whose log arguments are expensive to build (e.g. force layout reflow) */
  isDebug: () => isDebugEnabled,
  debug: (...args) => {
    if (isDebugEnabled) console.log(...args);
  },
  info: (...args) => {
    if (isDebugEnabled) console.info(...args);
  },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logToConsole;
